import { Sparkles, Skull, Ghost, PartyPopper, Wand2, Heart } from "lucide-react";

const ITEMS = [
  { icon: Sparkles, label: "Free shipping picks ★" },
  { icon: Skull, label: "Halloween 2026 — drops weekly" },
  { icon: Ghost, label: "Costumes from Amazon · eBay · curated" },
  { icon: PartyPopper, label: "Party supplies under $25" },
  { icon: Wand2, label: "Editor-picked group costumes" },
  { icon: Heart, label: "Couples + matching sets" },
];

export default function Marquee() {
  // Duplicate items so the loop is seamless
  const loop = [...ITEMS, ...ITEMS];
  return (
    <div
      className="overflow-hidden pcs-bg-blue text-white border-b-2 border-black"
      data-testid="top-marquee"
    >
      <div className="marquee-track py-2 font-mono text-xs uppercase tracking-[0.3em]">
        {loop.map((it, i) => {
          const Icon = it.icon;
          return (
            <span key={`${i}-${it.label}`} className="inline-flex items-center gap-2">
              <Icon className="w-4 h-4" strokeWidth={2.5} />
              <span>{it.label}</span>
              <span className="opacity-50">/</span>
            </span>
          );
        })}
      </div>
    </div>
  );
}
